<template>
    <div class="parents">
        <section class="home-cards">
        <h4>School Policies</h4>
        <hr class="hr">
        <p>Welcome to the school's resource center for all policies and guidelines for leaders and parents</p>
        <div class="home-cards-main">
            <div class="home-cards-cards">
              <router-link
                class="link"
                :to="{ name: 'Conduct'}"
              >
                <div class="feature">
                    <div class="feature-img undraw">
                    <img src="@/assets/stats.svg" alt="conduct">
                    </div>
                    <div class="feature-title">
                    <h5>Code of conduct</h5>
                    </div>
                    <div class="feature-detail">
                    <p>Click to view the parents/legal guardians code of conduct</p>
                    </div>
                </div>
              </router-link>
              <router-link
                class="link"
                :to="{ name: 'Refund'}"
              >
                <div class="feature">
                    <div class="feature-img undraw">
                    <img src="@/assets/cert.svg" alt="policy">
                    </div>
                    <div class="feature-title">
                    <h5>Refund Policy</h5>
                    </div>
                    <div class="feature-detail">
                    <p>Click to view the policy on refund of school fees and other payments</p>
                    </div>
                </div>
              </router-link>
              <router-link
                class="link"
                :to="{ name: 'SchoolBus'}"
              >
                <div class="feature">
                    <div class="feature-img undraw">
                    <img src="@/assets/school-bus.svg" alt="school bus">
                    </div>
                    <div class="feature-title">
                    <h5>School Buses</h5>
                    </div>
                    <div class="feature-detail">
                    <p>Click to view routes and times</p>
                    </div>
                </div>
              </router-link>
              <router-link
                class="link"
                :to="{ name: 'Meals'}"
              >
                <div class="feature">
                    <div class="feature-img undraw">
                    <img src="@/assets/breakfast.svg" alt="lunch">
                    </div>
                    <div class="feature-title">
                    <h5>Meals</h5>
                    </div>
                    <div class="feature-detail">
                    <p>Click to view the lunch menu</p>
                    </div>
                </div>
              </router-link>
              <router-link
                class="link"
                :to="{ name: 'TermReq'}"
              >
                <div class="feature">
                    <div class="feature-img undraw">
                    <img src="@/assets/terms.svg" alt="school term">
                    </div>
                    <div class="feature-title">
                    <h5>Termly Requirements</h5>
                    </div>
                    <div class="feature-detail">
                    <p>Click to view termly requirements</p>
                    </div>
                </div>
              </router-link>
              <router-link
                class="link"
                :to="{ name: 'Fees'}"
              >
                <div class="feature">
                    <div class="feature-img undraw">
                    <img src="@/assets/grid.svg" alt="fees">
                    </div>
                    <div class="feature-title">
                    <h5>Fee Structure</h5>
                    </div>
                    <div class="feature-detail">
                    <p>Click to view school fees</p>
                    </div>
                </div>
              </router-link>
              <router-link
                class="link"
                :to="{ name: 'Bank'}"
              >
                <div class="feature">
                    <div class="feature-img undraw">
                    <img src="@/assets/bank.svg" alt="bank details">
                    </div>
                    <div class="feature-title">
                    <h5>Bank Details</h5>
                    </div>
                    <div class="feature-detail">
                    <p>Click to view bank details</p>
                    </div>
                </div>
              </router-link>
            </div>
        </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'Parents',
  components: { }
}
</script>

<style>
.parents .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.parents .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.parents .home-cards .home-cards-main {
  display: grid;
  grid-gap: 0.8rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  padding: 1em;
}
.parents .home-cards .home-cards-cards {
  display: grid;
  grid-gap: 0.8rem;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}
.parents .home-cards-cards .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.parents .home-cards-cards .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.parents .home-cards-cards .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.parents .home-cards-cards .feature p {
  color: var(--inspire-charcoal);
}
.parents .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.parents .feature .feature-img.undraw {
  width: 85px;
  margin: 5px auto;
}
.parents .home-cards-cards .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
}
</style>
